import { createContext } from 'react'
import type { Context } from 'react'
import type { MassUploadStateType } from 'storeContext/reducers/massUpload'
import type { MassUploadDispatchType } from 'storeContext/actions/massUpload/types'

export interface MassUploadContextValueType {
  state: MassUploadStateType
  dispatch: MassUploadDispatchType
}

export const createMassUploadContext = (initialState: MassUploadStateType) =>
  createContext(initialState) as unknown as Context<MassUploadContextValueType>
